import politic from "public/politic.svg";
import social from "public/social.svg";
import economic from "public/economic.svg";
import prophetic from "public/prophetic.svg";
import finance from "public/finance.svg";
import sport from "public/sport.svg";
import scientific from "public/scientific.svg";

export const categories = [
  { id: "politic", title: "Քաղաքական", icon: politic },
  { id: "social", title: "Սոցիալական", icon: social },
  { id: "economic", title: "Տնտեսական", icon: economic },
  { id: "prophetic", title: "Մարգարեական", icon: prophetic },
  { id: "finance", title: "Ֆինանսական", icon: finance },
  { id: "sport", title: "Սպորտային", icon: sport },
  { id: "scientific", title: "Գիտական", icon: scientific },
];

export const info1 = [
  {
    title: "Կանխատեսումները չեն մնում խոսքի մակարդակում",
    description:
      "Համակարգը հետևում է դրանց իրականացմանը և փոփոխում հեղինակների  վարկանիշները։",
  },
  {
    title: "Օբյեկտիվ գնահատման մեխանիզմ",
    description:
      "Վարկանիշները ձևավորվում են կանխատեսումների ճշգրտության հիման վրա։",
  },
];

export const info2 = [
  {
    title: "Հետևեք ճշգրիտ կանխատեսողներին",
    description:
      "Բացահայտեք սխալվողներին և տեսեք, թե ինչպես են իրադարձությունները ձևավորում վարկանիշները։",
  },
  {
    title: "կողմնացույց ապագայի տեսլականների աշխարհում",
    description: "Վստահեք փաստերին, ոչ թե դատարկ խոստումներին։",
  },
];

export const slides = [
  {
    title: "Կանխատեսումները չեն մնում խոսքի մակարդակում",
    description:
      "Համակարգը հետևում է դրանց իրականացմանը և փոփոխում հեղինակների  վարկանիշները։",
  },
  {
    title: "Օբյեկտիվ գնահատման մեխանիզմ",
    description:
      "Վարկանիշները ձևավորվում են կանխատեսումների ճշգրտության հիման վրա։",
  },
  {
    title: "Հետևեք ճշգրիտ կանխատեսողներին",
    description:
      "Բացահայտեք սխալվողներին և տեսեք, թե ինչպես են իրադարձությունները ձևավորում վարկանիշները։",
  },
  {
    title: "Կողմնացույց ապագայի տեսլականների աշխարհում",
    description: "Վստահեք փաստերին, ոչ թե դատարկ խոստումներին։",
  },
];
